import api from './api';
import { Video, PaginatedResponse } from '../types';

interface VideoFilters {
  search?: string;
  category?: string;
  isPublic?: boolean;
  page?: number;
  limit?: number;
}

export const videosService = {
  async getList(filters: VideoFilters = {}): Promise<PaginatedResponse<Video>> {
    const params = new URLSearchParams();
    
    if (filters.search) params.append('search', filters.search);
    if (filters.category) params.append('category', filters.category);
    if (filters.isPublic !== undefined) params.append('isPublic', filters.isPublic.toString());
    if (filters.page) params.append('page', filters.page.toString());
    if (filters.limit) params.append('limit', filters.limit.toString());
    
    const response = await api.get<PaginatedResponse<Video>>('/videos', { params });
    return response.data;
  },

  async getById(id: number): Promise<Video> {
    const response = await api.get<Video>(`/videos/${id}`);
    return response.data;
  },

  async create(data: Omit<Video, 'id' | 'createdAt' | 'updatedAt'>): Promise<Video> {
    const response = await api.post<Video>('/videos', data);
    return response.data;
  },

  async update(id: number, data: Partial<Video>): Promise<Video> {
    const response = await api.put<Video>(`/videos/${id}`, data);
    return response.data;
  },

  async delete(id: number): Promise<void> {
    await api.delete(`/videos/${id}`);
  },

  async togglePublic(id: number): Promise<Video> {
    const response = await api.post<Video>(`/videos/${id}/toggle-public`);
    return response.data;
  },
};
